import { render, staticRenderFns } from "./NewChatFlowsSidebar.vue?vue&type=template&id=1c0c19ee&scoped=true"
import script from "./NewChatFlowsSidebar.vue?vue&type=script&lang=js"
export * from "./NewChatFlowsSidebar.vue?vue&type=script&lang=js"
import style0 from "./NewChatFlowsSidebar.vue?vue&type=style&index=0&id=1c0c19ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0c19ee",
  null
  
)

export default component.exports